import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeaveReport from "./Leave_report";
import NoLeaveReport from "./no_leave";

/**
 * Wraps the Leave Report and Unavailed Leave reports as tabs that toggle with
 * state (like the Overtime Report) — both stay mounted, so switching is instant
 * with no route change and no reload.
 */
const LeaveReportTabs = () => {
  const [activeTab, setActiveTab] = useState("leave");

  return (
    <div className="container-fluid mt-4">
      <ToastContainer position="bottom-right" />

      {/* Tabs */}
      <div className="mb-3 d-flex flex-wrap" style={{ gap: "10px" }}>
        <button
          type="button"
          className={`btn btn-sm ${activeTab === "leave" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setActiveTab("leave")}
        >
          Leave Report
        </button>
        <button
          type="button"
          className={`btn btn-sm ${activeTab === "unavailed" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setActiveTab("unavailed")}
        >
          Unavailed Leave
        </button>
      </div>

      {/* Both stay mounted; only the active one is shown */}
      <div style={{ display: activeTab === "leave" ? "block" : "none" }}>
        <LeaveReport />
      </div>
      <div style={{ display: activeTab === "unavailed" ? "block" : "none" }}>
        <NoLeaveReport />
      </div>
    </div>
  );
};

export default LeaveReportTabs;
